module.exports = __webpack_public_path__ + "static/img/bg-es.33476857.png";